import { createContext, useContext } from 'react';
import { type Copy, type Locale } from '@nexa/content';

export interface LocaleValue {
  readonly locale: Locale;
  readonly copy: Copy;
}

/**
 * Context + hook nằm ở file .ts KHÔNG chứa component, tách khỏi `LocaleProvider.tsx`.
 *
 * Lý do thực dụng: module vừa xuất component vừa xuất hook thì hot-reload phải nạp lại cả
 * cây con mỗi lần sửa, và state đang gõ trong form bị mất. Tách ra thì sửa provider chỉ ảnh
 * hưởng provider.
 */
export const LocaleContext = createContext<LocaleValue | null>(null);

function useLocaleValue(): LocaleValue {
  const value = useContext(LocaleContext);
  if (!value) {
    throw new Error(
      '[i18n] Thiếu <LocaleProvider>. Component phải nằm trong cây route của locale.',
    );
  }
  return value;
}

export function useLocale(): Locale {
  return useLocaleValue().locale;
}

/** Toàn bộ nội dung của ngôn ngữ hiện tại, đã có kiểu đầy đủ. */
export function useCopy(): Copy {
  return useLocaleValue().copy;
}
